export const typeValues = ['customer', 'agent', 'agent-prev'];
export const statusValues = ['sending', 'sent', 'received', 'seen', 'error'];